import React from "react";

/**
 * Xem trước thông báo theo kiểu thẻ push trên điện thoại. Thuần hiển thị —
 * nhận values realtime từ form (title/message/image/icon/color).
 */
function PushLivePreview({ values = {} }) {
    const { title, message, image, icon, color } = values;
    const accent = typeof color === "string" && color ? color : "#1677ff";

    return (
        <div
            style={{
                background: "rgb(var(--surface-muted))",
                borderRadius: 24,
                padding: 16,
                border: "1px solid rgb(var(--line))",
            }}
        >
            <div style={{ fontSize: 12, color: "#8c8c8c", textAlign: "center", marginBottom: 10 }}>
                Xem trước
            </div>
            <div
                style={{
                    // Giữ trắng CỐ Ý: đây là mô phỏng thẻ thông báo hiện
                    // trên điện thoại, không phải bề mặt của trang admin.
                    background: "#fff",
                    borderRadius: 14,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                    padding: 12,
                    borderLeft: `4px solid ${accent}`,
                }}
            >
                <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                    <div
                        style={{
                            width: 36,
                            height: 36,
                            borderRadius: 8,
                            background: icon ? `center/cover no-repeat url(${icon})` : accent,
                            flexShrink: 0,
                        }}
                    />
                    <div style={{ minWidth: 0, flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 14, color: "#1f1f1f", wordBreak: "break-word" }}>
                            {title || "Tiêu đề thông báo"}
                        </div>
                        <div style={{ fontSize: 13, color: "#595959", marginTop: 2, wordBreak: "break-word" }}>
                            {message || "Nội dung thông báo sẽ hiển thị ở đây…"}
                        </div>
                        <div style={{ fontSize: 11, color: "#bbb", marginTop: 4 }}>Long Housee · bây giờ</div>
                    </div>
                </div>
                {image ? (
                    <img
                        src={image}
                        alt="preview"
                        style={{ width: "100%", borderRadius: 8, marginTop: 10, objectFit: "cover", maxHeight: 160 }}
                        onError={(e) => {
                            e.currentTarget.style.display = "none";
                        }}
                    />
                ) : null}
            </div>
        </div>
    );
}

export default PushLivePreview;
